import {ActiveTableTreeConfig} from '@/components/Ui/ActiveTableTree/core/ActiveTableTree'
import store from '@/store/index'
import router from '@/routes'
import WikiNode from '@/models/wiki/wikiNode'
import WikiPage from '@/models/wiki/wikiPage'
import _ from 'lodash'

import titleComponent from '@/components/wiki/tree/title.vue'
import detailButtonComponent from '@/components/wiki/tree/detailButton.vue'
import {Message} from 'element-ui'

// @ts-ignore
import messages from '@/lang/index';

const WikiListTreeTableConfig: ActiveTableTreeConfig = {
  name: messages.wiki.list_page_name,
  tree: {
    cols: {
      title: {
        label: messages.labels.title,
        component: titleComponent
      }
    },
    treeProps: {
      label: 'title',
      isLeaf: 'leaf'
    },
    gridTemplateColumns: '1fr 100px 100px',
    async lazyMethod (node: {data: WikiNode, level: number}, resolve: (nodes: WikiPage[] | WikiNode[]) => any[]) {
      if (Array.isArray(node.data)) return [];
      let pages = await store.dispatch('wiki/pageList', node.data.getId())
      let children = node.data.getChildren()
      return resolve(_.concat(pages, children));
    }
  },
  detailButton: {
    component: detailButtonComponent
  },
  actions: [
    {
      name: messages.labels.edit,
      icon: 'edit',
      async handler (item) {
        if (item.isNode) {
          router.push({name: 'wikiNodeEdit', params: {id: item.getId()}})
        } else {
          router.push({name: 'wikiPageEdit', params: {id: item.getId()}})
        }
        return false
      }
    },
    {
      name: messages.labels.delete,
      icon: 'trash',
      async handler (item) {
        if (item.isNode) {
          await store.dispatch('wiki/deleteNode', item.getId())
          Message.success(messages.wiki.node_deleted)
        } else {
          await store.dispatch('wiki/deletePage', item.getId())
          Message.success(messages.wiki.single_node_deleted)
        }
        return true
      }
    }
  ]
}
export default WikiListTreeTableConfig
